import { createFileRoute } from '@tanstack/react-router';
import { TestPlanRunner } from '@/features/qa/TestPlanRunner';
import { validModule } from '@/features/qa/coverageModel';

/**
 * Esecuzione di una campagna: copertura + checklist dei flussi.
 *
 * `?module=` arriva dal cruscotto delle campagne e apre la checklist gia' filtrata su una
 * sezione. Si valida contro il vocabolario del catalogo: un valore inventato nell'URL
 * filtrerebbe via tutto e lascerebbe una pagina vuota che sembra un guasto.
 */
export const Route = createFileRoute('/_app/test-plans/$planId')({
  validateSearch: (s: Record<string, unknown>): { module?: string } => ({ module: validModule(s.module) }),
  component: PlanRunnerPage,
});

function PlanRunnerPage() {
  const { planId } = Route.useParams();
  const { module } = Route.useSearch();
  return <TestPlanRunner planId={planId} initialModule={module ?? null} />;
}
